<template>
  <div class="inspection-page">
    <div class="left-form" ref="madeForm">
      <avue-form :option="formOption" :value="detailForm" :disabled="true">
        <template #_totalCount>
          <el-progress :percentage="getPercentage(row)" :format="() => formatProgress(row)"></el-progress>
        </template>
      </avue-form>
    </div>
  </div>
</template>

<script>
import { disposeDetail } from '@/basic-common/util/common.js';
import { getUserList } from "../api";
import * as echarts from 'echarts'
import 'echarts/theme/macarons' // 引入主题增强样式
export default {
  props: {
    detailForm: {}
  },
  data () {
    return {
      gaugeChart: null,
      formOption: {
        menu: false,
        span: 8,
        detail: true,
        column: [
          { label: '记录编号', prop: 'recordCode' },
          {
            label: "检查类型",
            prop: "checkType",
            dicUrl: '/api/produce/safey-type/select/querySafeyType?safeyType=1',
            dataType: 'string',
            type: "select",
            props: {
              label: "typeName",
              value: "typeCode"
            },
          },
          {
            label: "受检对象",
            prop: "checkAreaCode",
            multiple: true,
            dicUrl: '/api/produce/safey-type/select/querySafeyType?safeyType=2',
            dataType: 'string',
            type: "select",
            props: {
              label: "typeName",
              value: "typeCode"
            },
          },
          { label: '检查日期', prop: 'checkDate' },
          {
            label: "检查人员",
            prop: "inspectorIds",
            dataType: 'string',
            type: "select",
            multiple: true,
            dicData: [],
            props: {
              label: "name",
              value: "id"
            },
          },
          {
            label: "验收人员",
            prop: "acceptPersonId",
            dataType: 'string',
            type: "select",
            multiple: true,
            dicData: [],
            props: {
              label: "name",
              value: "id"
            },
          },
          { label: '总检查项', prop: 'checkTotalCount' },
          { label: '符合项', prop: 'accordCount' },
          { label: '不符合项', prop: 'unAccordCount' },
          { label: '不适用项', prop: 'unApplayCount' },
          { label: '完成率(%)', prop: 'completedRate' },
          { label: '合格率(%)', prop: 'qualityRate' },
          { label: '发现问题', prop: 'problemCount' },
          { label: '已整改', prop: 'rectifiedCount' },
          { label: '待整改', prop: 'pendingCount' },
          {
            label: "执行进度",
            prop: "_totalCount",
          },
        ],
      },
    };
  },
  mounted () {
    this.init()
    // 初始化图表
    this.initGaugeChart(this.detailForm.completedRate)
  },
  methods: {
    init () {
      disposeDetail(this.$refs.madeForm)
      // 获取人员
      getUserList().then(({ data }) => {
        this.findObject(this.formOption.column, 'acceptPersonId').dicData = data
        this.findObject(this.formOption.column, 'inspectorIds').dicData = data
      })
    },
    initGaugeChart (value) {
      this.gaugeChart = echarts.init(this.$refs.gaugeChart, 'macarons')
      const option = {
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                color: '#1890ff'
              }
            },
            axisLine: {
              lineStyle: {
                width: 15
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              fontSize: 20,
              offsetCenter: [0, 0],
              formatter: '{value}%'
            },
            data: [
              {
                value: value
              }
            ]
          }
        ]
      }
      this.gaugeChart.setOption(option)
    },
    // 计算完成百分比
    getPercentage () {
      const row = this.detailForm
      // 避免除数为0的情况
      if (row.checkTotalCount === 0) return 0;
      return Math.round((row.finshTotalCount / row.checkTotalCount) * 100);
    },
    // 格式化显示文本
    formatProgress () {
      const row = this.detailForm
      return `${row.finshTotalCount}/${row.checkTotalCount}`;
    },

  }
};
</script>

<style scoped>
.gauge-chart {
  width: 100%;
  height: 200px;
}
::v-deep .avue-form__menu {
  display: none;
}
.inspection-page {
  display: flex;
  padding: 20px;
  gap: 20px;
  background-color: #fff;
}
.left-form {
  flex: 1;
}
.right-chart {
  width: 300px;
}
.chart-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.ring-chart {
  text-align: center;
  margin-bottom: 20px;
}
.ring {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 10px solid transparent;
  border-top-color: #28a745;
  border-right-color: #28a745;
  border-bottom-color: #e9ecef;
  border-left-color: #e9ecef;
  margin: 0 auto 10px;
  position: relative;
  --percent: 80%;
  transform: rotate(calc((var(--percent) * 3.6deg) - 90deg));
}
.statistics p {
  margin: 5px 0;
}
</style>
